export const getCallbackSourceCallId = (call, phoneNumber) => {
    if (!call || Number(call.call_check) !== 2) return null;
    if (!call.call_id || call.call_tel !== phoneNumber) return null;
    return call.call_id;
};
